var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6231 23H6.87685C5.01143 23 3.5 21.5018 3.5 19.6527V4.34732C3.5 2.49822 5.01143 1 6.87685 1H15.3423L20 5.63778V19.6527C20 21.5018 18.4886 23 16.6231 23Z",
    fill: "#EE3E2C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 5.63997H16.2994C15.7755 5.63997 15.3493 5.21983 15.3493 4.70041L15.3423 1.0022",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8771 7.86767C11.742 7.38981 11.416 7.15203 11.1412 7.18666C10.8081 7.22821 10.4542 7.42443 10.3121 7.73377C9.91618 8.61793 10.7453 11.2219 10.871 11.6582C10.0629 14.0729 7.30087 18.8469 5.9478 19.1701C5.91985 18.8538 6.08986 17.942 7.87377 16.8039C7.96692 16.7046 8.07172 16.5869 8.12063 16.5084C6.61153 17.2379 4.65761 18.4106 5.83368 19.2878C5.89656 19.3363 5.9967 19.3802 6.11082 19.4217C7.00976 19.7518 8.27201 18.6714 9.53891 16.2198C10.9339 15.7627 12.0611 15.4188 13.654 15.181C15.396 16.3537 16.5651 16.5915 17.3592 16.2891C17.5781 16.2037 17.9251 15.9313 18.0253 15.5734C17.3802 16.3606 15.8711 15.8112 14.6694 15.061C15.7803 14.9409 16.9284 14.8717 17.4244 15.0263C18.0556 15.2225 18.0346 15.5319 18.0253 15.5734C18.0742 15.4049 18.1464 15.1302 18.0113 14.9132C17.4803 14.0568 15.0443 14.5554 14.1594 14.6454C12.7644 13.8097 11.8002 12.3208 11.4113 11.2473C11.7723 9.86452 12.1612 8.86032 11.8794 7.86305M11.2786 10.7625C11.0457 9.9407 10.7196 8.11468 11.2436 7.52601C12.2707 8.10775 11.6326 9.49285 11.2786 10.7625ZM13.1976 14.8347C11.8515 15.0794 10.9386 15.4234 9.6274 15.9359C10.0163 15.1856 10.7546 13.2672 11.1086 12.0045C11.6046 12.9879 12.2055 13.9483 13.1976 14.8347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.2424401178bc3844a2ae0127f123183c.svg";
export { ForwardRef as ReactComponent };